// src/components/ProFeatureNotification.js
import React, { useState, useEffect } from 'react';
import { Crown, ArrowUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './ProFeatureNotification.module.css';

const ProFeatureNotification = ({ message, onUpgradeClick }) => {
  const [visible, setVisible] = useState(true);
  
  // Auto-hide after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <AnimatePresence>
      {visible && (
        <motion.div 
          className={styles.proNotificationOverlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div 
            className={styles.proNotification}
            initial={{ scale: 0.8, y: 50 }}
            animate={{ 
              scale: 1, 
              y: 0,
              transition: { 
                type: "spring", 
                stiffness: 300, 
                damping: 20 
              }
            }}
            exit={{ scale: 0.8, y: 50 }}
          >
            <div className={styles.notificationContent}>
              <div className={styles.crownContainer}>
                <Crown size={28} className={styles.crownIcon} />
              </div>
              <h3>Pro Feature</h3>
              <p>{message || "This feature is available with Pro subscription"}</p>
              <button 
                className={styles.upgradeButton}
                onClick={onUpgradeClick}
              >
                <span>Upgrade Now</span>
                <ArrowUp size={16} />
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ProFeatureNotification;